import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const LOGO = "/angel-logo.png";

export default function AppLayout({ children, sidebar }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="app-shell">
      <aside className="app-sidebar" data-testid="app-sidebar">
        <Link to="/" className="app-logo">
          <img src={LOGO} alt="Mi Ángel en Casa" />
          <span className="app-brand-text">Mi Ángel<small>en Casa</small></span>
        </Link>
        <nav className="app-nav">{sidebar}</nav>
        <div className="app-user">
          {user && (
            <>
              <div className="app-user-info">
                <strong>{user.nombre || user.email}</strong>
                <span>{user.role === "admin" ? "Administrador" : "Cliente"}</span>
              </div>
              <button onClick={handleLogout} data-testid="logout-btn" className="app-logout">
                <i className="fas fa-sign-out-alt" /> Salir
              </button>
            </>
          )}
        </div>
      </aside>
      <main className="app-main">{children}</main>
    </div>
  );
}
